import { ChangeDetectionStrategy, Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment';

import {
  Gallery,
  GalleryItem,
  ThumbnailsPosition,
  ImageSize,
  ImageItem
} from "ng-gallery";
import { Lightbox } from "ng-gallery/lightbox";
import { UserManagementService } from 'src/app/Service/user-management.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { MatSort, Sort } from '@angular/material/sort';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RemarkPopupComponent } from 'src/app/modals/remark-popup/remark-popup.component';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { MatSelect } from '@angular/material/select';

import { ReplaySubject, Subject } from 'rxjs';

import { take, takeUntil } from 'rxjs/operators';
import { Bank, BANKS } from './fertilizerlist-data'
interface sortBy {
  value: string;
  viewValue: string;
}
export interface BankGroup {
  name: string;
  banks: Bank[];
}
@Component({
  selector: 'app-fertilizerlist',
  templateUrl: './fertilizerlist.component.html',
  styleUrls: ['./fertilizerlist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe]
})

export class FertilizerlistComponent implements OnInit {
  form = new FormGroup({
    start: new FormControl([]),
    end: new FormControl([]),
  });

  statedata: any = [];
  displayedColumns: string[] = ['sentDate', 'notification', 'attachlink', 'states', 'updatedBy', 'action'];
  dataSource;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selection = new SelectionModel<PeriodicElement>(true, []);

  src = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  pdfSrc = 'http://www.pdf995.com/samples/pdf.pdf';

  //Image Viewer
  //items: GalleryItem[];
  @ViewChild("itemTemplate", { static: true }) itemTemplate: TemplateRef<any>;
  //imageData = data;
  selectedIndex = -1;
  userlist = [];
  userdata;
  restrictbutton = false;
  ReasonForReject;
  categoryname = [];
  exportcsvdata = false;
  getAverageCount: any = [];
  averageData;
  //sorting table
  dataSourcelist;
  @ViewChild(MatSort) sort: MatSort;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  fruits: any = [];
  totalcount;
  // state = [];
  statesList: any = []
  datepicker = [
    { value: '0', viewValue: '1 Week', startDate: new Date(new Date().setDate(new Date().getDate() - 7)), endDate: new Date() },
    { value: '1', viewValue: '1 Months', startDate: new Date(new Date().setDate(new Date().getDate() - 30)), endDate: new Date() },
    { value: '2', viewValue: '3 Months', startDate: new Date(new Date().setDate(new Date().getDate() - 90)), endDate: new Date() },
    { value: '3', viewValue: '6 Months', startDate: new Date(new Date().setDate(new Date().getDate() - 180)), endDate: new Date() },
    { value: '4', viewValue: '1 Year', startDate: new Date(new Date().setDate(new Date().getDate() - 365)), endDate: new Date() },
    { value: '5', viewValue: 'Custom Date' }
  ];
  selectFilterData1;
  today = new Date();
  customDate = false;
  edit = false;
  form1: FormGroup;
  reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  regexStr = '^[0-9]*$';
  /* Mat chip input */
  public matChipArray = [];
  submitted = false;
  getAverageData: any = [];
  ranges: any = {
    '1 Week': [moment().subtract(6, 'days'), moment()],
    '1 Month': [moment().subtract(29, 'days'), moment()],
    '3 Months': [moment().subtract(59, 'days'), moment()],
    '6 Months': [moment().subtract(179, 'days'), moment()],
    '1 Year': [moment().subtract(364, 'days'), moment()]
  }
  sortBy = [
    { value: '0', viewValue: 'Most Recent' },
    { value: '1', viewValue: 'Oldest Rating' },
    { value: '2', viewValue: 'Highest Rating' },
    { value: '3', viewValue: 'Lowest Rating' },

  ];

  datashow = true;
  datashowtrader = false;
  datashowfarmer = false;
  avtar = false;
  Viewprofile = false;
  datarole: string;
  hidepagination: boolean;
  maxDate; minDate;
  @ViewChild(DaterangepickerDirective, { static: false }) pickerDirective: DaterangepickerDirective;

  response;
  /** list of banks */
  protected banks: Bank[] = BANKS;

  /** total number of available entries */
  public allBanksSize = BANKS.length;

  /** control for the selected bank for multi-selection */
  public bankMultiCtrl: FormControl = new FormControl();

  public districtMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect ac keyword multi-selection */
  public bankMultiFilterCtrl: FormControl = new FormControl();

  public districtMultiFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword */
  public filteredBanksMulti: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(1);

  public filteredDistrictMulti: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(1);

  /** local copy of filtered banks to help set the toggle all checkbox state */
  protected filteredBanksCache: Bank[] = [];

  protected filteredDistrictCache = [];
  isIndeterminateDistrict = false;
  isCheckedDistrict = false;
  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;
  @ViewChild('multiSelectDistrict', { static: true }) multiSelectDistrict: MatSelect;

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();
  selectedSorting: string;

  constructor(private router: Router, public toastr: ToastrService, private fb: FormBuilder, public gallery: Gallery, private spinner: NgxSpinnerService, public lightbox: Lightbox, public _userService: UserManagementService, public datepipe: DatePipe, private ref: ChangeDetectorRef, public dialog: MatDialog) { }
  fcstates = [];
  ngOnInit(): void {
    // this.dataSource.paginator = this.paginator;
    this.form = this.fb.group({
      fcstates: [],
      start: [''],
      end: [''],
      searchText: [''],
    });

    this.form1 = this.fb.group({
      id: [''],
      notification: ['', [Validators.required]],
      attachlink: ['', [Validators.pattern(this.reg)]],
      states: [''],
      //remark: ['', [Validators.required]],
    });
    this.selectedIndex = 1
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    const lightboxRef = this.gallery.ref("lightbox");
    // Add custom gallery config to the lightbox (optional)
    lightboxRef.setConfig({
      imageSize: ImageSize.Cover,
      thumbPosition: ThumbnailsPosition.Top,
      itemTemplate: this.itemTemplate,
      gestures: false
    });
    this._userService.getStates().subscribe(data => {
      this.statedata = data
      this.statesList = this.statedata.result.data;
      this.spinner.hide();
    });
    this.selectedSorting = this.sortBy[0].viewValue;
    this.getAlluser();
    this.averageCount();

    this.filteredBanksMulti.next(this.banks.slice());

    this.filteredDistrictMulti.next(this.selectDistrict.slice());

    this.bankMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanksMulti();
        this.setToggleAllCheckboxState();
      });
    this.districtMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterDistrictMulti();
        this.districtSetToggleAllCheckboxState();
      });

    this.districtMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy)).subscribe(() => {
        this.districtSetToggleAllCheckboxState();
      });

    // listen for multi select field value changes
    this.bankMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy)).subscribe(() => {
        this.setToggleAllCheckboxState();
      });


  }
  suche() {
    setTimeout(() => {
      (document.querySelectorAll("#search1 div input")[1] as any).placeholder = "Search State";
    }, 5);
  }

  notFound() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll("#search1>div")[1] as any).innerText = "not found";
      }, 10);
    }
  }
  notFoundDistrict() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll("#search1>div")[1] as any).innerText = "not found";
      }, 10);
    }
  }
  sucheDistrict() {
    setTimeout(() => {
      (document.querySelectorAll("#search1 div input")[1] as any).placeholder = "Search District";
    }, 5)
  }
  /**
   * Sets the initial value after the filteredBanks are loaded initially
   */
  protected setInitialValue() {
    this.filteredBanksMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiSelect.compareWith = (a: Bank, b: Bank) => a && b && a.id === b.id;
      });
  }

  protected districtSetInitialValue() {
    this.filteredDistrictMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiSelectDistrict.compareWith = (a: Bank, b: Bank) => a && b && a.id === b.id;
      });
  }

  protected filterBanksMulti() {
    if (!this.banks) {
      return;
    }
    // get the search keyword
    let search = this.bankMultiFilterCtrl.value;
    if (!search) {
      this.filteredBanksCache = this.banks.slice();
      this.filteredBanksMulti.next(this.filteredBanksCache);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredBanksCache = this.banks.filter((bank: any) => bank.stateName.toLowerCase().indexOf(search) > -1);
    this.filteredBanksMulti.next(this.filteredBanksCache);
  }

  protected filterDistrictMulti() {
    if (!this.eligbleDistricts()) {
      return;
    }
    // get the search keyword
    let search = this.districtMultiFilterCtrl.value;
    if (!search) {
      this.filteredDistrictCache = this.eligbleDistricts().slice();
      this.filteredDistrictMulti.next(this.filteredDistrictCache);
      this.selectDistrict = this.filteredDistrictCache;
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredDistrictCache = this.eligbleDistricts().filter((item: any) => item.toLowerCase().indexOf(search) > -1);
    this.filteredDistrictMulti.next(this.filteredDistrictCache);
    this.selectDistrict = this.filteredDistrictCache;
  }

  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.bankMultiCtrl && this.bankMultiCtrl.value) {
      this.filteredBanksCache.forEach(el => {
        if (this.bankMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredBanksCache.length;
      this.isChecked = filteredLength > 0 && filteredLength === this.filteredBanksCache.length;
    }
  }

  protected districtSetToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.districtMultiCtrl && this.districtMultiCtrl.value) {
      this.filteredDistrictCache.forEach(el => {
        if (this.districtMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateDistrict = filteredLength > 0 && filteredLength < this.filteredDistrictCache.length;
      this.isCheckedDistrict = filteredLength > 0 && filteredLength === this.filteredDistrictCache.length;
    }
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredBanksMulti.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.bankMultiCtrl.patchValue(val);
        } else {
          this.bankMultiCtrl.patchValue([]);
        }
      });
  }

  toggleSelectAlldistrict(selectAllValue: boolean) {
    this.filteredDistrictMulti.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.districtMultiCtrl.patchValue(this.eligbleDistricts());
        } else {
          this.districtMultiCtrl.patchValue([]);
        }
      });
  }

  selectDistrict = [];

  filterMyOptions(items) {
    this.selectDistrict = [];
    if (this.bankMultiCtrl.value.length === 0) {

    } else {
      this.bankMultiCtrl.value.forEach(element => {
        this.selectDistrict = this.selectDistrict.concat(element.districtName);
      });
    }
  }

  eligbleDistricts() {
    let dist = [];
    if (this.bankMultiCtrl.value.length === 0) {

    } else {
      this.bankMultiCtrl.value.forEach(element => {
        dist = dist.concat(element.districtName);
      });
    }
    return dist;
  }

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  // }
  listPage() {
    this.edit = false;
  }

  editNotification(readdata) {
    this.edit = true;
    this.form1.get('id').setValue(readdata.fertilizerReminderID);
    this.form1.get('attachlink').setValue(readdata.attachlink);
    this.form1.get('notification').setValue(readdata.notification);
    this.form1.get('states').setValue(readdata.states.split(',  '));
  }

  newsTitle; Remark; Source;
  onSubmit() {
    this.submitted = true
    let x;
    const ref = this.openRemarkDialog();
    ref.afterClosed().subscribe(data => {
      x = data;

      if (this.form1.valid && x) {
        if (this.form1.value.attachlink != '') {
          var pattern = new RegExp(this.reg);
          var result = pattern.test(this.form1.value.attachlink);
          if (result == false) {
            alert('Please enter valid attach link')
            return false
          }
        }

        this.spinner.show();
        var formdata = {
          notification: this.form1.value.notification,
          states: this.form1.value.states,
          attachlink: this.form1.value.attachlink,
          remark: x,
          fertilizerId: this.form1.value.id
        }


        //if (confirm("Do you want to send this notification to selected state/s users?")) {
        this._userService.editFertilizerReminder(formdata).subscribe(data => {
          this.response = data;

          this.spinner.hide()
          this.toastr.success(this.response.result.message, 'Success', {
            timeOut: 3000,
          });

        });
        //}
        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/FertilizerList']);
          setTimeout(() => {
            location.reload();
          }, 2000)

        });
      }
      // else {
      //   alert("Please fill all mandatory fields and enter valid values")
      // }
    })

  }

  getAlluser() {
    var postdata = {
      "searchText": "",
      "fromDate": "",
      "toDate": "",
      "states": "",
      "pageNumber": 0
    }
    this._userService.getFertilizerReminderlist(postdata).subscribe(data => {
      this.userdata = data;
      // this.ref.detectChanges();
      this.userlist = this.userdata.result.data.list;
      this.paginationProperty = this.userdata.result.data;
      this.length = this.paginationProperty.totalItems;
      this.totalcount = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;
      this.dataSource = new MatTableDataSource(this.userlist);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.spinner.hide();
    });
  }

  contentLoaded() {
  }

  personName; phoneNo; role;
  TraderId;
  showDocument(data) {
    this.showinput = false
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);
    this.spinner.hide()
  }

  showinput = false;




  showViews(index: number) {
    this.selectedIndex = index
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /*.........................................PAGINATION CONFIG................................................. */
  paginationProperty;
  hasNextPage; hasPreviousPage; nextPageNumber; pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;
  length: number;
  previousPageIndex; pagechangeevent;
  public getServerData(event?: PageEvent) {

    this.pagechangeevent = event
    this.pageIndex = this.pagechangeevent.pageIndex
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;

    if (this.exportcsvdata == true) {

      var postdata = {
        fromDate: this.startdata,
        toDate: this.enddata,
        states: this.filterbystate.join(" "),
        searchText: this.filterbyText,
        PageNumber: this.pageIndex,
        pageSize: this.pageSize,
      }
      this._userService.getFertilizerReminderlist(postdata).subscribe(data => {
        this.userdata = data;
        this.userlist = this.userdata.result.data.list
        this.paginationProperty = this.userdata.result.data
        this.length = this.paginationProperty.totalItems
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber

        this.dataSource = new MatTableDataSource(this.userlist);
        // this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
        this.ref.detectChanges();
      });

    } else {
      postdata = {
        fromDate: "",
        toDate: "",
        states: "",
        searchText: "",
        PageNumber: this.pageIndex,
        pageSize: this.pageSize,
      }
      this.spinner.show();
      this._userService.getFertilizerReminderlist(postdata).subscribe(data => {
        this.userdata = data;
        this.ref.detectChanges();
        this.userlist = this.userdata.result.data.list
        this.paginationProperty = this.userdata.result.data
        this.length = this.paginationProperty.totalItems
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber

        this.dataSource = new MatTableDataSource(this.userlist);
        this.dataSource.sort = this.sort;
        this.ref.detectChanges();
      });
      this.spinner.hide();
    }

  }

  selectItem(item) {
    if (item.value == "Custom Date") {
      this.customDate = true;
    } else {
      this.customDate = false;
    }
  }
  clearFilter() {
    this.spinner.show();
    window.location.reload();
  }
  formPage() {
    this.router.navigate(['/Fertilizer']);
  }
  averageCount() {
    this._userService.getGetFertilizerReminderCount().subscribe(data => {
      this.averageData = data;
      this.getAverageData = this.averageData.result.data;
    });
  }


  startdata; enddata; sharedate;

  onDateRangeChanged(dates) {
    this.sharedate = dates;
    if (dates) {
      this.enddata = dates.endDate ? this.datepipe.transform(dates.endDate, 'yyyy/MM/dd HH:mm:ss') : null;
      this.startdata = dates.startDate ? this.datepipe.transform(dates.startDate, 'yyyy/MM/dd HH:mm:ss') : null;
    }

  }

  /*=========================================== apply filter ======================================================================== */
  filterbyText = ""; filterbystate = []; statedatafilter = ""; filterbyformdate = ""; filterbytodayte = ""; searchData;
  combinedate = ""; filterbysharedate;
  filterbysearchText = ""; searchText = ""; combinechip = "";
  formdate = "";
  todayte = "";
  applyfilter(checkEmpty) {

    this.matChipArray = [];
    let totalState = []
    if (this.statedata.length > 0) {
      this.statedata.forEach((ele: any) => {
        totalState.push(ele.stateName)
      })
    }
    if (checkEmpty && !this.searchData && !this.searchText && totalState.length == 0 && !this.sharedate.endDate && !this.sharedate.startDate) {
      alert('Please provide input first');
    } else {
      this.exportcsvdata = true;
      this.filterbyText = this.searchData;
      this.filterbystate = totalState;
      this.filterbysearchText = this.searchText;
      this.filterbysharedate = this.sharedate;
      this.filterbyformdate = this.enddata;
      this.filterbytodayte = this.startdata;

      // this.filterbytodayte = this.datepipe.transform(this.todayte, 'yyyy-MM-dd');
      let indexstate = this.matChipArray.findIndex(x => x.tag === 'state');
      let indexformdate = this.matChipArray.findIndex(x => x.tag === 'formdate');
      let indextodayte = this.matChipArray.findIndex(x => x.tag === 'todayte');
      let indexfilterbysearchText = this.matChipArray.findIndex(x => x.tag === 'searchText');
      let indexsharedate = this.matChipArray.findIndex(x => x.tag === 'sharedate');

      if (totalState != null) {
        totalState.forEach(ele => {
          // if (ele.indexstate > -1) {
          //   this.matChipArray[ele.indexstate].name = "State" + ":" + totalState;
          // } else {
          //   if (totalState != null && totalState != undefined) {
          //     this.matChipArray.push({ 'name': "State" + ":" + totalState, 'tag': 'state', 'flag': true })
          //   }
          // }
          this.matChipArray.push({ 'name': "State" + ":" + ele, 'tag': 'state', 'flag': true })

        })

      }


      if (this.searchText != '') {
        if (indexfilterbysearchText > -1) {
          this.matChipArray[indexfilterbysearchText].name = "SearchText" + ":" + this.searchText;
        } else {

          if (this.searchText != "" && this.searchText != undefined) {
            this.matChipArray.push({ 'name': "SearchText" + ":" + this.searchText, 'tag': 'searchText', 'flag': true })
          }
        }
      }

      if (this.sharedate && (this.startdata) && (this.enddata)) {
        if (indexsharedate > -1) {
          this.matChipArray[indexsharedate].name = "Shared date" + ":" + (this.sharedate['startDate'] ? this.sharedate['startDate'].format('MM/DD/YYYY') : '') + ' to ' + (this.sharedate['endDate'] ? this.sharedate['endDate'].format('MM/DD/YYYY') : '');
        } else {
          this.matChipArray.push({ 'name': "Shared date" + ":" + (this.sharedate['startDate'] ? this.sharedate['startDate'].format('MM/DD/YYYY') : '') + ' to ' + (this.sharedate['endDate'] ? this.sharedate['endDate'].format('MM/DD/YYYY') : ''), 'tag': 'sharedate', 'flag': true })
        }
      }



      var postdata = {

        fromDate: (this.startdata == undefined ? null : this.startdata),
        toDate: (this.enddata == undefined ? null : this.enddata),
        states: this.filterbystate.join(","),
        searchText: this.filterbysearchText,
        search: this.filterbyText,
        pageNumber: 0,
        pageSize: 10
      }
      this._userService.getFertilizerReminderlist(postdata).subscribe(data => {
        this.userdata = data
        this.userlist = this.userdata.result.data.list
        this.paginationProperty = this.userdata.result.data
        this.length = this.paginationProperty.totalItems
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber

        this.dataSource = new MatTableDataSource(this.userlist);
        // this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
        this.ref.detectChanges();
      });


    }
  }
  remove(index, tag): void {
    if (tag === 'state') {
      let removedState: any = this.matChipArray.splice(index, 1);
      // this.totalState = "";
      let val = JSON.parse(JSON.stringify(this.statedata));
      let i = val.findIndex(x => (removedState[0].name) === ('State:' + x.stateName));
      val.splice(i, 1);
      // this.bankMultiCtrl.setValue([]);
      this.bankMultiCtrl.setValue(val);
      // this.bankMultiCtrl.setValue(this.statedata);

    }
    if (tag === 'searchText') {
      this.matChipArray.splice(index, 1);
      this.searchText = "";
    }
    if (tag === 'sharedate') {
      this.matChipArray.splice(index, 1);
      this.sharedate = undefined;
    }
    setTimeout(() => {
      this.applyfilter(false);
    }, 500)
  }

  changeFn(event: any) {
    if (event.isTrusted == true) {
      this.applyfilter(false);
    }
  }

  formatDate(datetime) {

    return datetime.split(' ')[0] + ' ' + datetime.split(' ')[1] + ' ' + datetime.split(' ')[2];

  }
  /*=========================================== apply filter ======================================================================== */



  /*================================================= export file  ===================================================================================  */
  apidata; maindata; filename;


  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }
  exportcsv() {

    if (this.exportcsvdata == true) {
      this.applyfilter(false);
      var postdata = {
        SearchDate: this.filterbyformdate + "," + this.filterbytodayte,
        States: this.filterbystate.join(" "),
        SearchText: this.filterbysearchText,
        search: this.filterbyText,
      }
      this._userService.getAllUserFertilizerReminderpdf(postdata).subscribe(data => {
        this.apidata = data;
        const blob = new Blob([this.apidata], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.download = "PKF_Fertilizerlist.xlsx";
        anchor.href = url;
        anchor.click();
        // window.open(url);
      });

    } else {

      var postdata = {
        SearchDate: "",
        States: "",
        SearchText: "",
        search: "",
      }
      this._userService.getAllUserFertilizerReminderpdf(postdata).subscribe(data => {
        this.apidata = data;
        const blob = new Blob([this.apidata], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        // window.open(url);
        var anchor = document.createElement("a");
        anchor.download = "PKF_Fertilizerlist.xlsx";
        anchor.href = url;
        anchor.click();
      });
    }
  }
  /*================================================= export file  ===================================================================================  */

  /*===================================================== Column Based Export File =========================================  */

  dialogresult;
  mainresult
  openDialogexport(): void {
    const dialogRef = this.dialog.open(FertilizerDataExport, {
      width: '60%',
      height: '46%',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe(result => {
      this.dialogresult = result;
      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map(choice => (choice.value));
          let text = confirm("Are you sure you want to export this file?");
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyfilter(false);
              var postdata = {
                "fromDate": (this.startdata == undefined ? null : this.startdata),
                "toDate": (this.enddata == undefined ? null : this.enddata),
                "states": this.filterbystate.join(" "),
                "searchText": this.filterbysearchText,
                "search": this.filterbyText,
                "reportKeyList": Result
              }
              this._userService.getAllUserFertilizerReminderpdf(postdata).subscribe(data => {
                this.apidata = data;
                const blob = new Blob([this.apidata], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                var anchor = document.createElement("a");
                anchor.download = "PKF_Fertilizerlist";
                anchor.href = url;
                anchor.click();
              });
            } else {
              postdata = {
                "fromDate": "",
                "toDate": "",
                "states": "",
                "searchText": "",
                "search": "",
                "reportKeyList": Result
              }

              this._userService.getAllUserFertilizerReminderpdf(postdata).subscribe(data => {
                this.apidata = data;
                const blob = new Blob([this.apidata], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                // window.open(url);
                var anchor = document.createElement("a");
                anchor.download = "PKF_Fertilizerlist.xlsx";
                anchor.href = url;
                anchor.click();
              });
            }
          } else {
            this.openDialogexport();
          }
        } else {
          alert('Please select atleast any one columns to generate report!');
          this.openDialogexport();
        }
      }

    })
  }


  openRemarkDialog() {
    const dialogRef = this.dialog.open(RemarkPopupComponent, {

    });
    return dialogRef;
  }
  /*===================================================== Export File =========================================  */

  /*model pop up same page  */
  openDialog(data): void {
    const dialogRef = this.dialog.open(DeletFertilizer, {
      // width: '30%',
      // height: '30%',
      data: { id: data }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.applyfilter(false);
      this.averageCount();



    });
  }
  /*model pop up same page  */

}

export interface PeriodicElement {

  DocumentName: string;

  Date: string;

  Status: string;

  IsVerified: string;

  UploadedBy: string;

}

@Component({
  selector: 'delete-fertilizer',
  templateUrl: 'delete-fertilizer.html',
})
export class DeletFertilizer {
  formdelet: FormGroup;
  response;
  constructor(
    public dialogRef: MatDialogRef<DeletFertilizer>,
    @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, public _userService: UserManagementService, public toastr: ToastrService, private router: Router) { }
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.formdelet = this.fb.group({
      Remark: ['', [Validators.required]],
    });

  }
  onSubmit() {

    if (this.formdelet.valid) {
      var postdata = {
        'fertilizerId': this.data.id,
        'remark': this.formdelet.value.Remark,
      }
      this._userService.removeFertilizerReminder(postdata).subscribe(data => {
        this.response = data;
        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
        this.dialogRef.close();
      });

    } else {
      alert('Please enter valid remark !')
      return false;
    }
  }
}

//colunm based export fuctionality
@Component({
  selector: 'fertilizer-data-export',
  templateUrl: 'fertilizer-data-export.html',
})
export class FertilizerDataExport {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<FertilizerDataExport>,
    @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, public _userService: UserManagementService, public toastr: ToastrService, private router: Router) {
    this.masterSelected = false;
    this.checklist = [
      { id: 1, viewValue: 'Notification', value: 'Notification', isSelected: false },
      { id: 2, viewValue: 'States', value: 'States', isSelected: false },
      { id: 3, viewValue: 'Attached Link', value: 'Attachlink', isSelected: false },
      { id: 4, viewValue: 'Sent Date', value: 'SentDate', isSelected: false },
    ];
    this.getCheckedItemList();
  }

  ngOnInit(): void {
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);

  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}

